import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import {
  DSAction,
  useActionsTableContext,
} from '../../../../ActionsTableContext'
import { useSoftRemoveDsActionMutation } from 'schema'

export function useRemove(): RemoveRowActionOptions<DSAction> {
  const { refetch } = useActionsTableContext()
  const [softRemove] = useSoftRemoveDsActionMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveDSAction: {
        action: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ submittals }) =>
      !!submittals.length
        ? {
            message:
              'Actions cannot be deleted if they are associated with one or more Design Submittals',
          }
        : false,
    permission: Permission.RemoveRestoreDesignSubmittalAction,
    onRemove: async ({ id }) => {
      await softRemove({ variables: { id } })
      refetch()
    },
  }
}
